export default __webpack_public_path__ + "static/media/texture-dotted.ef81d8b3.svg";